import api from '../../api/busLocation'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

const getDefaultState = () => {
  return {
    all: [],
    target: [],
    groupedTrips: [],
    stopTime: {},
    shapes: [],
    isOpen: false,
    isShowLocation: false
  }
}

const state = getDefaultState()

const getters = {
  getStops: (state) => state.all.stops,
  getSelectedStops: (state) => state.target,
  getGroupedTrips: (state) => state.groupedTrips.sort(function (a, b) {
    return (moment(a.estimateDepTime) > moment(b.estimateDepTime) ? 1 : -1)
  }),
  getStopTime: (state) => state.stopTime,
  getShapes: (state) => state.shapes,
  getIsOpen: (state) => state.isOpen,
  getIsShowLocation: (state) => state.isShowLocation
}

const actions = {
  fetchAll ({ commit }) {
    return new Promise((resolve) => {
      api.getLocationStops()
        .then(stops => {
          commit('setStops', stops)
          resolve()
        })
    })
  },
  updateSelectedStops ({ commit }, stops) {
    commit('setTarget', stops)
  },
  getGroupedTrips ({ commit }, params) {
    return new Promise((resolve) => {
      api.getGroupedTrips(params)
        .then(groupedTrips => {
          commit('setGroupedTrips', groupedTrips)
          resolve()
        })
    })
  },
  getStopTime ({ commit }, params) {
    return new Promise((resolve) => {
      api.getStopTime(params)
        .then(stopTime => {
          commit('setStopTime', stopTime)
          commit('setIsShowLocation', true)
          resolve()
        })
    })
  },
  getShapes ({ commit }, params) {
    return new Promise((resolve) => {
      api.getShapes(params)
        .then(shapes => {
          commit('setShapes', shapes)
          resolve()
        })
    })
  },
  openBusLocation ({ commit }) {
    commit('setIsOpen', true)
    commit('setIsShowLocation', false)
  },
  closeBusLocation ({ commit }) {
    commit('setIsOpen', false)
    commit('setIsShowLocation', false)
  },
  close ({ commit }) {
    commit('setTarget', {})
    commit('setIsOpen', false)
    commit('setIsShowLocation', false)
  },
  resetStopTime ({ commit }) {
    commit('resetStopTime')
  }
}

const mutations = {
  setStops (state, stops) {
    state.all = stops
  },
  setTarget (state, target) {
    state.target = target
  },
  setGroupedTrips (state, groupedTrips) {
    state.groupedTrips = groupedTrips
  },
  setStopTime (state, stopTime) {
    state.stopTime = stopTime
  },
  setShapes (state, shapes) {
    state.shapes = shapes
  },
  setIsOpen (state, isOpen) {
    state.isOpen = isOpen
  },
  setIsShowLocation (state, isShowLocation) {
    state.isShowLocation = isShowLocation
  }, 
  resetStopTime (state) {
    state.stopTime = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
